import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Typography, Box } from "@mui/material";
import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import InsurersTable from "../../../components/tables/InsurersTable.jsx";
import { useInsurerPermissions } from "../../../hooks/permissions/useInsurerPermissions.jsx";

/**
 * Insurers List Page
 * Shows a list of insurers; a row opens the insurer detail page.
 */
export default function InsurerIndexPage() {
  const { setBreadcrumbs } = useBreadcrumb();
  const navigate = useNavigate();
  const { canView } = useInsurerPermissions();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Versicherungsgesellschaften", path: "/admin/insurers" },
    ]);
  }, [setBreadcrumbs]);

  const openInsurer = (row) => {
    if (!canView(row)) {
      return;
    }

    navigate(`/admin/insurers/${row.id}`);
  };

  return (
    <Box>
      {/* Page Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h1" gutterBottom>
          Versicherungsgesellschaften
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Übersicht aller Versicherungsgesellschaften mit Kontaktdaten
        </Typography>
      </Box>

      <InsurersTable onRowClick={openInsurer} />
    </Box>
  );
}
